module.exports = __webpack_public_path__ + "img/banner_news.b8101aed.jpg";